import { Component, Injector, Input, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ImporterComponent } from '../importer/importer.component';

@Component({
    selector: 'app-manual-importer',
    templateUrl: './manual-importer.component.html',
    styleUrls: ['./manual-importer.component.scss']
})
export class ManualImporterComponent {

    @Input() public mode: 'inventory' | 'deck' = 'inventory';

    public readonly dialogRef: MatDialogRef<ManualImporterComponent>;

    @ViewChild('importer', {static: true}) private readonly importer: ImporterComponent;

    constructor(private readonly injector: Injector) {
        this.dialogRef = this.injector.get(MatDialogRef, null);
    }

    public importCards(cards): void {
        if (this.dialogRef) {
            this.dialogRef.close(cards);
        }
    }

    public cancel(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    public triggerImport(): void {
        this.importer.getCardsToImport().subscribe(qtyAndCards => {
            if (this.dialogRef) {
                this.dialogRef.close(qtyAndCards);
            }
        });
    }

}
